
define({
  copySuccess: 'Copied',
  copyFail: 'Failed to copy',
  day: 'day',
  hour: 'h',
  minute: 'm',
  second: 's',
})
